import axios from "axios";
import router from "../router";

let host = window.location.host;
if (/^localhost/.test(host)) {
  axios.defaults.baseURL = "http://localhost:3001/api/v1";
} else {
  axios.defaults.baseURL = "/api/v1";
}

axios.interceptors.request.use((config) => {
  const token = window.sessionStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

axios.interceptors.response.use(
  (response) => {
    if (response.data.status === 1006 || response.data.code === 1006) {
      window.sessionStorage.removeItem("token");
      router.push("/login");
      return Promise.reject(new Error("登录已过期"));
    }
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      window.sessionStorage.removeItem("token");
      router.push("/login");
    }
    return Promise.reject(error);
  }
);

export default {
  install(app) {
    app.config.globalProperties.$http = axios;
  }
};
